<template>
  <section class="site-section-v">
    <div class="site-container">
      <p class="text-grey-dark">
        Crivelli Advogados Associados conta com especialistas em diversas áreas
        jurídicas focadas nos direitos dos trabalhadores brasileiros e de suas
        entidades profissionais. Consultorias, assessorias, pareceres e
        advocacia de excelência em direito do trabalho, previdenciário, civil,
        sindical e direito médico. Confira o escopo de atuação de cada área.
      </p>
      <expertise-area
        :show-title="false"
        :mobile-vertical="true"
        :items="areas"
      />
      <hr />
      <form-contact
        title="Entre em contato"
        @submit="(data) => submitContact(data)"
      >
        <template #info><contact-info /></template>
      </form-contact>
      <hr />
      <download-app />
    </div>
  </section>
</template>

<script>
import ExpertiseArea from "@/components/Home/ExpertiseArea";
import DownloadApp from "@/components/Home/DownloadApp";
import FormContact from "@/components/FormContact";
import ContactInfo from "@/components/ContactInfo";
import api from "../../services/api";

export default {
  components: { DownloadApp, FormContact, ContactInfo, ExpertiseArea },

  async created() {
    await this.getAreas();
  },

  data() {
    return {
      currentTab: 0,
      profiles: [],
      areas: [],
    };
  },

  computed: {
    teamTypes() {
      // return ["Sócios", "Advogados", "Estagiários", "Administrativo"];
      return ["Sócios"];
    },
  },

  methods: {
    async getAreas() {
      const { data: areas } = await api.get("areas");
      this.areas = areas;
    },
    submitContact() {},
  },
};
</script>

<style>
</style>
